import Link from "next/link";

import PropTypes from "prop-types";

import { Items } from "./Items";

export const OrderedItems = ({
  data,
  orderId,
  canCancel,
  orderDate,
  orderStatus,
  orderNumber,
}) => {
  const canReview = orderStatus === "delivered";

  return (
    <div className="rounded-[0.75rem] border border-[#EBEEF2]">
      <div className="border-b-1 flex items-center justify-between rounded-t-[0.75rem] border-[#EBEEF2] p-5">
        <p className="text-[1.125rem] font-semibold leading-[1.75rem] text-grayDisplay-900">
          Ordered Items
        </p>

        {canCancel && (
          <p className="cursor-pointer font-medium text-[#E81E61]">
            <Link href={`/order-cancel-confirm/${orderId}`}>Cancel Order</Link>
          </p>
        )}
      </div>

      <div className="border-b border-[#EBEEF2]" />
      {data?.map((el, i) => (
        <Items
          {...el}
          key={i}
          orderId={orderId}
          canReview={canReview}
          orderDate={orderDate}
          orderNumber={orderNumber}
        />
      ))}
    </div>
  );
};

OrderedItems.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      main_picture: PropTypes.string,
      product_name: PropTypes.string,
      product_number: PropTypes.number,
      quantity: PropTypes.number,
      price: PropTypes.number,
      discount_amount: PropTypes.number,
      offer_percent: PropTypes.number,
      offer_price: PropTypes.number,
      discount: PropTypes.number,
      total: PropTypes.number,
      id: PropTypes.string,
      product_slug: PropTypes.string,
    })
  ),
  orderId: PropTypes.string,
  orderStatus: PropTypes.string,
  canCancel: PropTypes.bool,
};
